const triglycerideLevel = {
  Unknown: 1,
  Low: 2,
  Elevated: 3,
  High: 4
}

export default triglycerideLevel;